import React, { Component } from 'react';
import { Grid, Typography, CardContent, Card, Chip, Badge } from '@mui/material';
import TotalStatusesChart from './Resources/Charts/TotalStatusesChart';
import AnomalieChart from './Resources/Charts/AnomalieChart';
import { FUNCTION_URL } from './Constants/index';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Divider from '@mui/material/Divider';
var authProvider = require('./authProvider');

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: "",
            totalRegman: 0,
            magazzini: [],
            regmanStatus0: 0,
            regmanStatus1: 0,
            regmanStatus2: 0,
            regmanStatus3: 0
        }
    }

    // section = {
    //     height: "100%",
    //     backgroundColor: "#fff"
    // };

    async componentDidMount() {
        let user_data = authProvider.getData().data;

        let role = user_data.role;
        role = role.charAt(0).toUpperCase() + role.slice(1)

        if (user_data.role === "approvatore") {
            role = role + ": " + authProvider.getData().data.tipologia.split('_').join(" ")
        }

        this.setState({
            tipologia: authProvider.getData().data.tipologia,
            aoa: authProvider.getData().data.aoa,
            magazziniList: authProvider.getData().data.cod_terr_sap?.split(','),
            configuredMagazziniList: authProvider.getData().data.configured_cod_terr_sap?.split(','),
            blockedMagazziniList: authProvider.getData().data.blocked_magazzini?.split(','),
            configured_blocked_magazzini: authProvider.getData().data.configured_blocked_magazzini?.split(',')
        })

        let impresa = localStorage.getItem("codice_impresa_desc");
        impresa = (!impresa || impresa === "") ? [""] : JSON.parse(impresa);
        let cod_terr_sap = localStorage.getItem('cod_terr_sap');

        cod_terr_sap = (!cod_terr_sap || cod_terr_sap === "") ? [] : JSON.parse(cod_terr_sap);
        let magazzini = cod_terr_sap.toString()?.split(',');

        this.setState({
            profile: role + " " + impresa[0],
            magazzini: magazzini,
            totalRegman: 'Loading...'
        });

        let params = {
            chartName: 'TotalRegman',
            cod_terr_sap_array: localStorage.getItem('cod_terr_sap')
        }

        let regmanStats;
        if (user_data.role !== 'administrator' && user_data.role !== 'dg') {
            regmanStats = await fetch(FUNCTION_URL + '/GetChartData', {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain',
                    'x-zumo-auth': localStorage.getItem('auth-token')
                },
                body: JSON.stringify(params)
            })
                .then(response => {
                    if (response.status === 200) {
                        return response.text();
                    }
                    else {
                        return undefined
                    }
                })
                .catch(error => {
                    console.log(error);
                    return error;
                });
        }


        if (regmanStats) {
            regmanStats = JSON.parse(regmanStats);

            if (regmanStats.message) {

                console.log("Ddashboard - TotalRegman erro: " + regmanStats.message)
                this.setState({
                    totalRegman: "Errore durante il recupero dei dati"
                });
            }
            else {
                if (regmanStats.totalRegman && regmanStats.totalRegman > 0) {
                    this.setState({
                        totalRegman: regmanStats.totalRegman
                    });
                }
                else {
                    this.setState({
                        totalRegman: 0
                    });
                }
                if (regmanStats.statusRegman) {
                    this.setState({
                        regmanStatus0: regmanStats.statusRegman.status0,
                        regmanStatus1: regmanStats.statusRegman.status1,
                        regmanStatus2: regmanStats.statusRegman.status2,
                        regmanStatus3: regmanStats.statusRegman.status3
                    });
                }
                else {
                    this.setState({
                        regmanStatus0: 0,
                        regmanStatus1: 0,
                        regmanStatus2: 0,
                        regmanStatus3: 0
                    });
                }
            }
        }
    }

    render() {
        return (
            <div>
                <Grid container spacing={2} sx={{ paddingTop: '1rem' }}>
                    <Grid item xs={12} md={2}>
                        <Card >
                            <CardContent >
                                <Typography color="textPrimary" variant="h6" gutterBottom>Profilo</Typography>
                                <Divider sx={{ marginBottom: '1rem' }} />
                                <Chip color="primary" variant="outlined" icon={<AccountCircleIcon />} label={this.state.profile} />
                            </CardContent>
                        </Card>
                    </Grid>
                    {(this.props.permissions !== 'administrator' && this.props.permissions !== 'approvatore' && this.props.permissions !== 'dg') &&
                        <Grid item xs={12} md={6}>
                            <Card >
                                <CardContent >
                                    <Typography variant="h6" color="textPrimary" gutterBottom>Magazzini</Typography>
                                    <Divider sx={{ marginBottom: '1rem' }} />
                                    {this.state.magazzini?.map((mag, i) => <Chip label={mag} color="primary" key={i} sx={{ marginRight: '3px' }} />)}
                                </CardContent>
                            </Card>
                        </Grid>}
                    {(this.props.permissions === 'approvatore' && this.state.tipologia === 'profilo_speciale') &&
                        <><Grid item xs={12} md={2}>
                            <Card >
                                <CardContent >
                                    <Typography variant="h6" color="textPrimary" gutterBottom>AOA</Typography>
                                    <Divider sx={{ marginBottom: '1rem' }} />
                                    <Chip label={this.state.aoa} color="primary" />
                                </CardContent>
                            </Card>
                        </Grid>
                            <Grid item xs={12} md={6}>
                                <Card >
                                    <CardContent >
                                        <Typography variant="h6" color="textPrimary" gutterBottom>Magazzini</Typography>
                                        <Divider sx={{ marginBottom: '1rem' }} />
                                        {this.state.configuredMagazziniList?.map((mag, i) => <Chip label={mag} color="primary" key={i} sx={{ marginRight: '3px' }} />)}
                                    </CardContent>
                                </Card>
                            </Grid></>}
                    {(this.props.permissions === 'approvatore' && this.state.tipologia === 'profilo_su_magazzino') &&
                        <Grid item xs={12} md={6}>
                            <Card >
                                <CardContent >
                                    <Typography variant="h6" color="textPrimary" gutterBottom>Magazzini</Typography>
                                    <Divider sx={{ marginBottom: '1rem' }} />
                                    {this.state.magazziniList?.map((mag, i) => <Chip label={mag} color="primary" key={i} sx={{ marginRight: '3px' }} />)}
                                </CardContent>
                            </Card>
                        </Grid>}
                    {(this.props.permissions === 'approvatore' && this.state.tipologia === 'profilo_su_area') &&
                        <><Grid item xs={12} md={2}>
                            <Card >
                                <CardContent >
                                    <Typography variant="h6" color="textPrimary" gutterBottom>AOA</Typography>
                                    <Divider sx={{ marginBottom: '1rem' }} />
                                    <Chip label={this.state.aoa} color="primary" />
                                </CardContent>
                            </Card>
                        </Grid>
                            <Grid item xs={12} md={6}>
                                <Card >
                                    <CardContent >
                                        <Typography variant="h6" color="textPrimary" gutterBottom>Magazzini bloccati</Typography>
                                        <Divider sx={{ marginBottom: '1rem' }} />
                                        {this.state.configured_blocked_magazzini ? this.state.configured_blocked_magazzini.map((mag, i) => <Chip label={mag} color="error" key={i} sx={{ marginRight: '3px' }} />)
                                        : <Chip label={"Nessuno"} color="primary" key={0} sx={{ marginRight: '3px' }} />}
                                    </CardContent>
                                </Card>
                            </Grid></>}
                    {(this.props.permissions !== 'administrator' && this.props.permissions !== 'dg' && this.props.permissions !== 'approvatore') &&
                        <Grid item xs={12} md={4}>
                            <Card >
                                <CardContent>
                                    <Typography variant="h6" color="textPrimary" >Stato Regman</Typography>
                                    <Divider sx={{ marginTop: '0.5rem' }} />
                                    <Grid container spacing={2} sx={{ paddingTop: '1rem' }}>
                                        <Grid item xs={4}>
                                            <Badge badgeContent={this.state.totalRegman} color="primary">
                                                <Chip label="Identificati da Regman" />
                                            </Badge>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Badge badgeContent={this.state.regmanStatus0} color="primary">
                                                <Chip label="Non identificati da Regman" />
                                            </Badge>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Badge badgeContent={this.state.regmanStatus3} color="primary">
                                                <Chip label="Match Regman OK" />
                                            </Badge>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Badge badgeContent={this.state.regmanStatus2} color="primary">
                                                <Chip label="Match Regman KO" />
                                            </Badge>
                                        </Grid></Grid>
                                </CardContent>
                            </Card>
                        </Grid>}
                    {(this.props.permissions !== 'approvatore' && this.props.permissions !== 'administrator' && this.props.permissions !== 'dg') &&
                        <><Grid item xs={12} md="6">
                            <Card >
                                <CardContent><TotalStatusesChart /></CardContent>
                            </Card>
                        </Grid>
                            <Grid item xs={12} md="6">
                                <Card >
                                    <CardContent>
                                        <Typography variant="h6" color="textPrimary" gutterBottom>Distribuzione Casi “Da Esaminare”</Typography>
                                        <Divider sx={{ marginBottom: '1rem' }} />
                                        <AnomalieChart />
                                    </CardContent>
                                </Card>
                            </Grid></>
                    }
                </Grid>
            </div>
        );
    }
}

export default Dashboard;